export default __webpack_public_path__ + "static/media/img-integrations.26a5b4d4.svg";